module.exports = __webpack_public_path__ + "configuration/config_deva.json";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=configuration/config_deva.json!./src/config/config_deva.json
// module id = 538
// module chunks = 3